"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var alt_1 = require("../../alt");
var api_request_1 = require("../../api_request");
var location_util_1 = require("../../shared/location_util");
var url_helpers_1 = require("../../shared/url_helpers");
function getUrl(params) {
    if (params.curated_set_slug) {
        return url_helpers_1.default.curatedSetCollectionHeaderPath(params.curated_set_slug);
    }
    if (params.curated_search_slug) {
        return url_helpers_1.default.curatedSearchCollectionHeaderPath(params.curated_search_slug);
    }
    if (params.brand_slug) {
        return url_helpers_1.default.brandCollectionHeaderPath(params.brand_slug);
    }
    if (params.landing_page_slug) {
        return url_helpers_1.default.landingPageCollectionHeaderPath(params.landing_page_slug);
    }
    if (params.product_type) {
        if (params.category) {
            return url_helpers_1.default.categoryCollectionHeadersPath(params.product_type, params.category);
        }
        return url_helpers_1.default.productTypeCollectionHeaderPath(params.product_type);
    }
    // digital listings
    if (params.category_id) {
        return url_helpers_1.default.categoryCollectionHeaderPath(params.category_id);
    }
    return null;
}
function shouldHideHeader(params) {
    return !getUrl(params) ||
        (location_util_1.default.isOnMarketplacePage() && params.query);
}
var CollectionHeaderActionsBase = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionHeaderActionsBase, _super);
    function CollectionHeaderActionsBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollectionHeaderActionsBase.prototype.collectionHeaderLoaded = function (data) {
        return data;
    };
    CollectionHeaderActionsBase.prototype.clear = function () {
        return null;
    };
    CollectionHeaderActionsBase.prototype.fetchOrClear = function (params) {
        var _this = this;
        if (shouldHideHeader(params)) {
            this.clear();
            return null;
        }
        var fetchUrl = getUrl(params);
        var fetchParams = { locale: params.locale };
        var req = api_request_1.V3.get(fetchUrl, fetchParams);
        req.fail(function () {
            _this.clear();
        });
        req.then(function (response) {
            _this.collectionHeaderLoaded({ response: response, params: params });
        });
        return new Promise(function (success, err) {
            req.then(function (r) { success(r); });
            req.fail(function (r) { return err(r); });
        });
    };
    return CollectionHeaderActionsBase;
}(alt_1.AltActions));
exports.CollectionHeaderActions = alt_1.default.createActions(CollectionHeaderActionsBase);
var CollectionHeaderStoreBase = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionHeaderStoreBase, _super);
    function CollectionHeaderStoreBase() {
        var _this = _super.call(this) || this;
        _this.collectionHeader = null;
        _this.params = null;
        _this.bindActions(exports.CollectionHeaderActions);
        return _this;
    }
    CollectionHeaderStoreBase.prototype.onCollectionHeaderLoaded = function (data) {
        var collectionHeader = Array.isArray(data.response.collection_headers) ?
            data.response.collection_headers[0] :
            data.response;
        this.setState({
            collectionHeader: collectionHeader,
            params: data.params,
        });
    };
    CollectionHeaderStoreBase.prototype.onClear = function () {
        this.setState(this.initialState());
    };
    CollectionHeaderStoreBase.prototype.initialState = function () {
        return {
            collectionHeader: null,
            params: null,
        };
    };
    return CollectionHeaderStoreBase;
}(alt_1.AltStoreModel));
exports.CollectionHeaderStore = alt_1.default.createStore(CollectionHeaderStoreBase, 'CollectionHeaderStore');
//# sourceMappingURL=collection_header_store.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/stores/collection_header_store.js
// module id = 8oiH
// module chunks = 20 21